import Promotions       from './component/Promotions';
import PromotionsDetail from './component/PromotionsDetail';

export const promotions = {
  firstLevel:  Promotions,
  secondLevel: PromotionsDetail,
};